import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../utils/api';
import './AdminLoginPage.css';

export default function AdminForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          err.message ||
          'Could not send the reset email. Try again in a moment.'
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>🏗 Real Estate Data Analyzer</h1>
          <p>Reset your password</p>
        </div>

        {error && <div className="admin-login-error">{error}</div>}

        {sent ? (
          <>
            <p className="admin-login-note">
              If an account exists for <strong>{email}</strong>, a reset link is on its way.
              The link opens on the main AI Broker site — the password you set there is the
              same one you use to sign in here.
            </p>
            <p className="admin-login-note">
              <Link to="/login">← Back to sign in</Link>
            </p>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmit} className="admin-login-form">
              <label>
                Email
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                  placeholder="you@example.com"
                />
              </label>
              <button type="submit" className="admin-login-btn" disabled={busy}>
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
            </form>

            <p className="admin-login-note">
              <Link to="/login">← Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
